import gate from '@/api/axios';

/**
 * Получает аттачи категорий услуг
 * @async
 * @function serviceCategoriesAttach
 * @returns {Promise}
 */
export const serviceCategoriesAttach = async () => gate.get('/serviceCategories/icons');

/**
 * Получает категории услуг
 * @async
 * @function serviceCategories
 * @returns {Promise}
 */
export const serviceCategories = async () => gate.get('/serviceCategories');

/**
 * Сохраняет порядок категорий услуг
 * @async
 * @function reorderServiceCategories
 * @returns {Promise}
 */
export const reorderServiceCategories = async (ids) => gate.patch('/serviceCategories/sort', { ids });

/**
 * Создает категорию услуг
 * @async
 * @function createServiceCategory
 * @returns {Promise}
 */
export const createServiceCategory = async (payload) => gate.post('/serviceCategories', payload);

/**
 * Обновляет категорию услуг
 * @async
 * @function updateServiceCategory
 * @returns {Promise}
 */
export const updateServiceCategory = async (payload) => gate.patch(`/serviceCategories/${payload.id}`, payload);

/**
 * Удаляет категорию услуг
 * @async
 * @function deleteServiceCategory
 * @returns {Promise}
 */
export const deleteServiceCategory = async (payload) => gate.delete(`/serviceCategories/${payload.id}`);

/**
 * Сохраняет порядок услуг внутри категории
 * @async
 * @function reorderCategoryServices
 * @returns {Promise}
 */
export const reorderCategoryServices = async (categoryId, ids) => gate.patch(`/serviceCategories/${categoryId}/services/sort`, { ids });

/**
 * Создает услугу
 * @async
 * @function createService
 * @returns {Promise}
 */
export const createService = async (payload) => gate.post(`/serviceCategories/${payload.id}/services`, payload);

/**
 * Обновляет услугу
 * @async
 * @function updateService
 * @returns {Promise}
 */
export const updateService = async (payload) => gate.patch(`/serviceCategories/${payload.id}/services/${payload.serviceId}`, payload);

/**
 * Удаляет услугу
 * @async
 * @function deleteService
 * @returns {Promise}
 */
export const deleteService = async (payload) => gate.delete(`/serviceCategories/${payload.id}/services/${payload.serviceId}`);

/**
 * Добавляет дополнительную опцию к услуге
 * @async
 * @function createServiceOption
 * @returns {Promise}
 */
export const createServiceOption = async (payload) => gate.post(`/serviceCategories/${payload.id}/services/${payload.serviceId}/options`, payload);

/**
 * Обновляет дополнительную опцию к услуге
 * @async
 * @function updateServiceOption
 * @returns {Promise}
 */
export const updateServiceOption = async (payload) => gate.patch(`/serviceCategories/${payload.id}/services/${payload.serviceId}/options/${payload.optionId}`, payload);

/**
 * Удаляет дополнительную опцию к услуге
 * @async
 * @function deleteServiceOption
 * @returns {Promise}
 */
export const deleteServiceOption = async (payload) => gate.delete(`/serviceCategories/${payload.id}/services/${payload.serviceId}/options/${payload.optionId}`);
